import { PrinterActions } from '@/features/settings/components/PrintManagement/types'
import Button from '@/features/ui/buttons/components/Button'
import IconButton from '@/features/ui/buttons/components/IconButton'
import DeleteIcon from '@/features/ui/icons/components/DeleteIcon'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

type ActionsProps = {
    printerId: string
} & PrinterActions

const iconButtonSize = 40

const Actions: FC<ActionsProps> = ({ printerId, onEditPrinter, onDeletePrinter }) => {
    const { t } = useTranslation()

    const handleEditButtonPress = () => onEditPrinter(printerId)
    const handleDeleteButtonPress = () => onDeletePrinter(printerId)

    return (
        <View style={styles.actions}>
            <Button
                type="primary"
                style={{ marginHorizontal: 'auto' }}
                onPress={handleEditButtonPress}
            >
                {t('settings.printers.printManagement.printerSettings').toUpperCase()}
            </Button>
            <IconButton
                size={iconButtonSize}
                type="outline"
                color="secondary"
                Icon={DeleteIcon}
                onPress={handleDeleteButtonPress}
            />
        </View>
    )
}

const styles = StyleSheet.create({
    actions: {
        flexDirection: 'row',
        gap: 8,
        width: '100%',
        justifyContent: 'space-between',
        paddingTop: 8,
        paddingLeft: iconButtonSize,
    },
})

export default Actions
